module.exports = __webpack_public_path__ + "img/story-cta.8130947f.svg";